import "./style.css";
import { useEffect, useState } from "react";
import { Drawer, Row, Col, Radio, Space, RadioChangeEvent } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import LockResetIcon from "@mui/icons-material/LockReset";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import { Password } from "../UI/User-Password/Changepassword";
import { ModalInfo } from "./modalInfo";
import { useLanguage } from "../ContextAPI/LanguageContext";

type userProps = {
  sett: boolean;
  setSettings: React.Dispatch<React.SetStateAction<boolean>>;
};

const UsersSettings = (props: userProps) => {
  const [openpassword, setOpenpassword] = useState(false);
  const [show] = useState(true);
  const [openinfo, setOpenInfo] = useState(false);
  const [t, i18n] = useTranslation("common");
  const { lang, setLang } = useLanguage();
  const dir = i18n.dir();
  const onClose = () => {
    props.setSettings(false);
  };

  const updateDirection = (language: string | null) => {
    const body = document.body;
    if (body) {
      body.dir = language === 'ar' ? 'rtl' : 'ltr';
    }
  };

  const onLanguageChange = (e: RadioChangeEvent) => {
    const value = e.target.value
    setLang(value);
    localStorage.setItem('language', value);
    updateDirection(value);
  };

  useEffect(() => {
    if (!lang) {
      localStorage.setItem('language', 'en');
      setLang('en');
      return;
    }
    localStorage.setItem('language', lang);
    i18n.changeLanguage(lang);
    updateDirection(lang);
    setLang(lang);
  }, [lang, i18n]);

  return (
    <>
      <Drawer
        width="270px"
        onClose={onClose}
        style={{
          background: "#0047FF",
          zIndex: 4,
          opacity: "0.85",
          overflow: "hidden",
        }}
        closable={false}
        open={props.sett}
        placement={dir === "ltr" ? "right" : "left"}
        bodyStyle={{ overflow: "hidden" }}
      >
        <Row className="spaces">
          <Col span={20}>
            <Space>
              <UserOutlined className="iconsize" />
              <span>{localStorage.getItem("userName")}</span>
            </Space>
          </Col>
        </Row>
        <Row className="spaces">
          <Col span={20}>
            <Space>
              <LockResetIcon style={{ fontSize: "24px" }} />
              <span
                style={{ cursor: "pointer" }}
                onClick={() => setOpenpassword(true)}
              >
                {t("change-password")}
              </span>
            </Space>
          </Col>
        </Row>
        <Row>
          <Col span={3}>
            <LanguageOutlinedIcon
              style={{ fontSize: "24px", color: " white", marginTop: "12px" }}
            />
          </Col>
          <Space>
            <Radio.Group
              name="radiogroup"
              value={lang}
              onChange={onLanguageChange}
            >
              <Space direction="vertical">
                <Col offset={1} className="spaces">
                  {t("language")}
                </Col>
                <Radio className="space" value={"en"}>
                  {t("english")}
                </Radio>
                <Radio className="space" value={"ar"}>
                  {t("arabic")}
                </Radio>
              </Space>
            </Radio.Group>
          </Space>
        </Row>
      </Drawer>
      <Password
        openpassword={openpassword}
        setOpenpassword={setOpenpassword}
        show={show}
        requireOldPassword={true}
      />
      <ModalInfo openinfo={openinfo} setOpenInfo={setOpenInfo} />
    </>
  );
};

export default UsersSettings;
